import { render, staticRenderFns } from "./currency-input.vue?vue&type=template&id=678e39a9"
import script from "./currency-input.vue?vue&type=script&lang=js"
export * from "./currency-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678e39a9')) {
      api.createRecord('678e39a9', component.options)
    } else {
      api.reload('678e39a9', component.options)
    }
    module.hot.accept("./currency-input.vue?vue&type=template&id=678e39a9", function () {
      api.rerender('678e39a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/currency-input.vue"
export default component.exports